import classNames from 'classnames';
import moment from 'moment';
import React from 'react';
import env from 'utils/env';
import { renderFormattedMessageText } from 'utils/messageFormatting';
import Avatar from '../Avatar/Avatar';
import styles from './Message.module.scss';
function Message({ id, author, avatar, date, text, picture, sendByMe, size = 's', showName, showDate, }) {
    const classes = classNames(styles.wrap, styles[size], { [styles.sendByMe]: sendByMe });
    return (React.createElement("article", { className: classes, "data-testid": id },
        !sendByMe && (React.createElement("div", { className: styles.avatar }, showName && (React.createElement(Avatar, { size: "s", userName: author, src: avatar ? `${env.static}/${avatar}` : undefined })))),
        React.createElement("div", { className: styles.content, title: moment(date).format('HH:MM, DD.MM.YYYY') },
            picture && (React.createElement("blockquote", null,
                React.createElement("img", { src: `${env.static}/${picture}`, alt: "" }))),
            text && React.createElement("blockquote", null, renderFormattedMessageText(text, styles.mention)),
            showDate && React.createElement("p", { className: styles.date }, moment(date).fromNow()))));
}
export default Message;
